import { render, staticRenderFns } from "./ListItemSR.vue?vue&type=template&id=2b3be00e&scoped=true"
import script from "./ListItemSR.vue?vue&type=script&lang=js"
export * from "./ListItemSR.vue?vue&type=script&lang=js"
import style0 from "./ListItemSR.vue?vue&type=style&index=0&id=2b3be00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3be00e",
  null
  
)

export default component.exports